import { useNavigate } from 'react-router-dom';
import DashboardAppService from '../../../../application/platform/scp/dashboard/dashboard-app-service';
import { ACTION_TYPES, useDashboardDispatch, useDashboardState } from "./dashboard-context";
import { useFeedback } from '../../../../hooks/use-feedback';

export const useDashboardController = () => {
    const navigate = useNavigate();
    const { showError, withLoading } = useFeedback();
    const dispatch = useDashboardDispatch();
    const { selectedYear, startDate, endDate } = useDashboardState();

    async function loadData() {
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });
        try {
            const dashboardData = await withLoading(() => DashboardAppService.getOverview({ year: selectedYear, startDate, endDate }));
            dispatch({ type: ACTION_TYPES.setDashboardData, payload: dashboardData });
        } catch (error: any) {
            showError('Não foi possível carregar o painel de controle', error);
        } finally {
            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
        }
    }

    function handleYearChange(year: number) {
        dispatch({
            type: ACTION_TYPES.setSelectedYear,
            payload: year
        });
    }

    function handleStartDateChange(date?: Date) {
        dispatch({
            type: ACTION_TYPES.setStartDate,
            payload: date
        });
    }

    function handleEndDateChange(date?: Date) {
        dispatch({
            type: ACTION_TYPES.setEndDate,
            payload: date
        });
    }

    function navigateToPurchases() {
        navigate('/compras-licitacoes');
    }

    function navigateToContracts() {
        navigate('/contratos');
    }

    return {
        loadData,
        handleYearChange,
        handleStartDateChange,
        handleEndDateChange,
        navigateToPurchases,
        navigateToContracts
    };
}
